export default {"src":"/_next/static/media/instructorImage.65952d2a.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};